<template>
	<div class="instructionsComponent">
		<div class="playerInstructions">
			<div class="instruction" v-for="instruction in instructions" :key="instruction.key">
				<span class="key">{{instruction.key}}</span> = {{instruction.name}}
			</div>
		</div>
	</div>
</template>

<script>

  export default {
    name: 'Instructions',
    props: {
      keyMap: {type: Object, required: true},
    },
    computed: {
      instructions() {
        return Object.entries(this.keyMap).map(([key, item]) => ({key, name: item.name}));
      },
    },
  };

</script>


<style scoped>
	.playerInstructions {
		display: flex;
		justify-content: center;
		font-size: 12px;
		margin-top: 8px;
	}

	.instruction {
		margin: 0 5px;
	}

	.key {
		font-weight: bold;
		text-transform: uppercase;
	}
</style>


